import { radius, space, tok, tokPx, verticalGap } from '@sunwebgroup/ui-components'
import { Skeleton } from '@sunwebgroup/ui-components/uds'
import { styled } from 'styled-components'

const Wrapper = styled.div`
  position: relative;
  width: 280px;
  box-shadow: ${tok('primitives_box_shadows_level_2')};
  border-radius: ${radius('primitives_corner_radius_l')};
  background-color: ${tok('semantics_views_background_color')};
  height: 100%;
`

const ProductImage = styled(Skeleton)`
  object-fit: cover;
  border-radius: ${radius('primitives_corner_radius_l')} ${radius('primitives_corner_radius_l')} 0px 0px;
  height: 215px;
  width: 280px;
`

const Heading = styled(Skeleton)`
  height: ${tokPx('typography_display_i_regular_font_size')};
  width: 70%;
`

const Footer = styled.div`
  padding: ${space('primitives_space_16')};
  display: flex;
  flex-direction: column;

  ${verticalGap('spacing_xs')}
`

const SubHeading = styled(Skeleton)`
  height: ${tokPx('typography_body_s_regular_tight_font_size')};
  width: 50%;
`

export function ProductAdLoading() {
  return (
    <Wrapper>
      <ProductImage />
      <Footer>
        <Heading />
        <SubHeading />
      </Footer>
    </Wrapper>
  )
}
